module.exports = __webpack_public_path__ + "static/media/PlutoLight.8e319ee4.svg";